export default function Tos() {
  return (
    <article className="legal card">
      <h1>Terms of Service</h1>
      <p>
        <em>Startup Project Management</em> — operated by <strong>LineSpotting AB</strong>. Last
        updated 2026-08-05.
      </p>
      <h2>1. Service</h2>
      <p>
        We provide project and team management software for startups (web and mobile apps), including
        people/skills profiles, org structure tools, tasks, light Gantt, budget/runway views, and
        optional AI features when you supply your own API key.
      </p>
      <h2>2. Accounts &amp; subscriptions</h2>
      <p>
        Paid access is sold as auto-renewable subscriptions: <strong>User $9/year</strong> and{" "}
        <strong>Admin $19/year</strong> (or nearest store price points), via Apple App Store, Google
        Play, and later web payments. Manage or cancel in the respective store account settings.
        Refunds follow store policies.
      </p>
      <h2>3. Acceptable use</h2>
      <p>
        You may not abuse the service, attempt unauthorized access, or upload unlawful content. You
        are responsible for data you enter about your team.
      </p>
      <h2>4. AI features</h2>
      <p>
        Optional AI uses your own xAI API key. You pay xAI directly. Suggestions are not automatically
        applied; you must accept changes. AI outputs may be inaccurate.
      </p>
      <h2>5. Disclaimer</h2>
      <p>
        Budget tools are planning aids, not accounting, tax, or investment advice. Service provided
        “as is” to the extent permitted by law.
      </p>
      <h2>6. Contact</h2>
      <p>
        Operator: LineSpotting AB — David Rad
        <br />
        Email:{" "}
        <a href="mailto:info@linespotting.com">info@linespotting.com</a>
        <br />
        Phone: +46 480 888 87
        <br />
        Privacy:{" "}
        <a href="https://linespotting.com/privacy-policy/" target="_blank" rel="noreferrer">
          https://linespotting.com/privacy-policy/
        </a>
      </p>
    </article>
  );
}
